import {
  OptionPosition,
  OptionType,
  LONG,
  SHORT,
  CALL,
  PUT,
  isCall,
  isPut,
  isLong,
  isShort,
} from 'utils/shared/quantlib/utils';
import { TickerEntries } from 'constants/opc';

export type { OptionPosition, OptionType };
export { LONG, SHORT, CALL, PUT, isCall, isPut, isLong, isShort };

// expiration (optional), strike (optional), currentSpot (required), contractMultiplier (optional, default 1)
// Are any of these arrays or single paramters and build outward? Or allow array for more flexibility but likely always passing a single value?

/**
 * @note DOES ANY OF THIS NEED TO BE IN ARRAY FORM FOR FLEXIBILITY? What happens when we start updating individual legs?
 * @note Some way to scale out the strikes or expirations? Ex: saddle with very different strikes for more perceived movement
 * @note WHAT HAPPENS WITH CUSTOM STRATEGIES WHERE THE LEGS ARE KNOWN? DO WE NEED ANOTHER FUNCTION THAT THESE ALL SEND TO?
 * So initialize a strategy and then customize the items inside it.
 */

export interface StrategyInputParams {
  chain: TickerEntries['entries'];
  spot: number;
  expirationDate?: Date; // Find reasonable default value if not provided
  expirationKey?: string;
  strike?: number; // Find reasonable default value if not provided
  strikeDirection?: 'mid' | 'bid' | 'ask';
  contractMultiplier?: number; // Assume 1 if not provided
  /**
   * @note may not use these initially
   * We will go out further indexes in the array for the strike or premium if these are set
   */
  premiumMultiplier?: number; // Assume 1 if not provided
  expirationMultiplier?: number; // Assume 1 if not provided
}

export interface StrategyBuilderParams {
  premium: number;
  numberOfContracts: number;
  expirationDate: Date;
  expirationKey: string;
  strike: number;
  position: OptionPosition;
  type: OptionType;
}

export interface StockPosition {
  price: number;
  quantity: number;
}

export type StrategyBuilderFunction = (params: StrategyInputParams) => {
  optionPositions: StrategyBuilderParams[];
  stockPositions: StockPosition[];
};

export const EMPTY_STRATEGY = {
  optionPositions: [],
  stockPositions: [],
};
